module.exports = __webpack_public_path__ + "static/media/BG02.ab6ea84b.png";